module.exports = __webpack_public_path__ + "static/location-cb1aa1afb8ae77cafa8c2a5b3af714d6.jpg";